$(document).ready(function () {
    initSelects();
});

function initSelects() {
    let select2Inputs = $("select.select2_input");

    select2Inputs.map(function () {
        let input = $(this);
        input.select2({
            allowClear: input.attr("data-allow-clear") === "true",
            multiple: input.attr("data-multiple") === "true",
            placeholder: input.attr("data-placeholder"),
            minimumResultsForSearch:
                input.attr("data-search-enabled") === "false" ? -1 : 0,
            dropdownCssClass: "moonly_select2_dropdown",
        });
    });
}
